export enum MODAL_NAME {
	REPORT = 'report',
	CEATE_RBIDOS_REQUEST = 'ceate_rbidos_request',
	EXIT_OCHKA_RBIDOS_REQUEST = 'exit_ochka_rbidos_request',
	SPK = 'spk',
	MESSAGE_LANDING = 'message_landing',
	EMAIL = 'email',
	CONFIRM = 'confirm',
	REGION_LANDING = 'region_landing',
	FORM_LANDING = 'form_landing',
	DOC_DOC = 'doc_doc',
	SBEREGI_BIZNES = 'sberegi_biznes',
	INSALES = 'insales',
	SBER_MOBILE = 'sber_mobile',
	RBIDOS_LEAD = 'rbidos_lead',
	RBIDOS_IIT = 'rbidos_iit',
	RBIDOS_LEAD_ERROR = 'rbidos_lead_error',
	RBIDOS_LEAD_SUCCESS = 'rbidos_lead_success',
	INFO = 'info',
	EDIT_ADDRESS_RBIDOS_REQUEST = 'edit_address_rbidos_request',
	SOCKET_RBIDOS_REQUEST = 'socket_rbidos_request',
	CHANGE_PASSWORD_PROFILE = 'change_password_profile',
	CHANGE_USERNAME_PROFILE = 'change_username_profile',
	DELETE_PACKAGE_OKVED = 'delete_package_okved',
	SAVE_PACKAGE_OKVED = 'save_package_okved',
	ORDERS_BLOCK = 'orders_block',
	ORDER_CREATE = 'order_create',
	REASSIGN_CONFIRM = 'reassign_confirm',
	PRODUCT_ONE_PAGE = 'product_one_page',
	RESTART_ORDER = 'restart_order',
	RESTART_ORDER_SUCCESS = 'restart_order_success',
	PARTNER_PAYMENT = 'partner_payment',
	FILE_PREVIEW = 'file_preview',
	MESSAGE_LANDING_VED = 'message_landing_ved',
	CABINET_SUPPORT = 'cabinet_support',
	AGREEMENT_BG = 'agreement_bg',
	TRUST_SETTINGS_CREATE = 'trust_settings_create',
	TRUST_SETTINGS_UPDATE = 'trust_settings_update',
	TRUST_SETTINGS_DELETE = 'trust_settings_delete',
	FIND_OUT_YOUR_INN = 'find_out_your_inn',
	CAPABILITIES_DETAILS = 'capabilities_details',
	CAPABILITIES_DESCRIPTION = 'capabilities_description',
	SPOD = 'spod',
	MERCHANT_ACQUIRING = 'merchant_acquiring',
	NEW_CONSENT = 'new_consent',
	RESEND_CODE_CONSENT = 'resend_code_consent',
	ERROR_CONSENT = 'error_consent',
	VIDEO_VIEW = 'video_view',
	FEEDBACK = 'feedback',
	CALC_COMMISSION = 'calc_commission',
	UNSIGNED_ORDERS = 'unsigned_orders',
	KR_PRODUCT_ERROR = 'kr_product_error',
	SAVE_AGREEMENT_DOCUMENT = 'save_agreement_document',
	RESERVE_ACCOUNT_CARD = 'reserve_account_card',
	CONFIRM_RESERVE = 'confirm_reserve',
	CHANGE_LEAD_BG = 'change_lead_bg',
	CUSTOMER_LIMIT = 'customer_limit',
	PARTNER_REQUEST_CHANGE_STATUS = 'partner_request_change_status',
	PARTNER_REQUEST_AGREEMENT_STATUS = 'partner_request_change_agreement_status',
	SIGN_RBIDOS_DOCS = 'sign_rbidos_docs',
	UNLOAD_REPORT_RBIDOS = 'unload_report_rbidos',
	DASHBOARD_SETTINGS = 'dashboard_settings',
	CONFIRM_DELETE_NOTIFICATION = 'confirm_delete_notification',
	DOUBLE_GIS = 'double-gis',
	CREATE_TAG_PARTNER_DOCUMENT = 'create_tag_partner_document',
	EDIT_CONTRACTS_REGISTRY = 'edit_contracts_registry',
	CHANGE_STATUS_CONTRACTS = 'change_status_contracts',
	PARTNER_CONTRACTS_EXPORT_CONFIG = 'partner_contracts_export_config',
	SHOW_ADDITIONAL_AGREEMENTS = 'show_additional_agreements',
	PARTNER_CONTRACTS_SETTING_GRID = 'partner_contracts_setting_grid',
	REMOVE_CONTRACT_REGISTRY = 'remove_contract_registry',
	BUSINESSAPP_CARD = 'businessapp_card',
	CLIENT_DOCUMENTS = 'client_documents',
	HEADER_REPORTS = 'header_reports',
	CHANGE_MODAL = 'change_modal',
	ADDRESS_INFO_MODAL = 'address_info_modal',
	OKVED_LIST_MODAL = 'okved_list_modal',
	OKVED_PACKAGE_MODAL = 'okved_package_modal',
	OKVED_TYPES_MODAL = 'okved_types_modal',
	SAVE_TEMPLATE_MODAL = 'save_template_modal',
	TASK_MODAL = 'task_modal',
	FREE_SERVICES_MODAL = 'free_services_modal',
	BUSINESSAPP_MODAL = 'businessapp_modal',
	RBIDOS_ACCESS_COMMENT_MODAL = 'RBIDOS_ACCESS_COMMENT_MODAL',
	BLOCKING_AGENT = 'BLOCKING_AGENT',
	NEW_PASSWORD_AGENT = 'NEW_PASSWORD_AGENT',
	CANCEL_STATUSES = 'cancel_statuses',
	ADD_PLATFORM = 'add_platform',
	ADD_MEDIA = 'add_media',
	ADD_PUBLICATION = 'add_publications',
	BG_REWORK = 'bg_rework',
	BG_NOTIFICATION_SETTING = 'bg_notification_setting',
	INFOTECS_LOGIN = 'INFOTECS_LOGIN',
	REPEAT_IDENTIFICATION = 'REPEAT_IDENTIFICATION',
	SIGNATURE_MODAL = 'SIGNATURE_MODAL',
	PROCESSING_MODAL = 'PROCESSING_MODAL',
	CANCEL_IDENTIFICATION_MODAL = 'CANCEL_IDENTIFICATION_MODAL',
	COPY_ORDERS_REDESIGN_CABINET = 'COPY_ORDERS_REDESIGN_CABINET',
	AGREEMENT_MODAL = 'AGREEMENT_MODAL',
	FILE_PREVIEW_CABINET = 'file_preview_cabinet',
	REPORT_AUTOMATION = 'report_automation',
	RECOGNIZED_PASSPORT = 'recognized_passport',
	CREATIVE_UNLOAD_REPORT = 'creative_unload_report',
	REPORTS_MODAL = 'reports_modal',
	SENT_NOTIFY_WARNING = 'sent_notify_warning',
	SENT_NOTIFY_DANGER = 'sent_notify_danger',
	SENT_ORDERS_REPORTS = 'sent_orders_reports',
	UPLOAD_ORDER_STATUS = 'upload_orders_status',
	INFOTECS_EXIT = 'INFOTECS_EXIT',
	ARCHIVE_BROKER_EXPORT = 'ARCHIVE_BROKER_EXPORT',
	REJECTED_VALIDATION_MODAL = 'REJECTED_VALIDATION_MODAL',
	PARTNER_PROFILE_INIVATE = 'partner_profile_inivate',
	EXTENDED_REPORT = 'extended_report',
	REFERAL_LINKS = 'referal_links',
	ANTIFRAUD = 'antifraud',
	FORM_BLACK_LIST_PARTNER = 'FORM_BLACK_LIST_PARTNER',
	CHOOSE_PARTNER = 'choose_partner',
	EXCEL_ACT = 'excel_act',
	ADD_UPDATE_NEWS = 'add_update_news',
	RELATED_PRODUCTS = 'related_products',
	DELETE_REQUEST_MODAL = 'DELETE_REQUEST_MODAL',
	ORDERS_RECOGNIZED_PASSPORT = 'ORDERS_RECOGNIZED_PASSPORT',
	ASSIGN_ORDER = 'ASSIGN_ORDER',
	RESERVE_CONFIRMATIOM = 'reserve_confirmation',
	PARTNER_ONE_DAY_CHANGE_STATUS = 'partner_one_day_change_status',
	PARTNER_ONE_DAY_DISTRIBUTION_FORM = 'partner_one_day_distribution_form',
	CREATE_ORDER_CANCELLATION = 'create_order_cancellation',
	BANK_EMPLOYEES_FORM = 'bank_employees_form',
	DASHBOARD_AVATAR = 'dashboard_avatar',
	AGREEMENT_SMS_INFO = 'agreement_sms_info',
	VIEW_USTAV_HELPER = 'view_ustav_helper',
	VIEW_BASE_USTAV = 'view_base_ustav',
	MOYA_BUHGALTERIYA_AUTSORSING = 'moya_buhgalteriya_autsorsing',
	USER_CONSENT_MODAL = 'USER_CONSENT_MODAL',
	SIGNED_CONTRACT_FLAG_MODAL = 'signed_contract_flag_modal',
	SVETOFOR_CHECK_REPORT = 'svetofor_check_report',
	AUTH_REFRESH_PASSWORD = 'auth_refresh_password',
	REGISTER_SERVICES = 'register_services',
	PATENT_MODAL = 'patent_modal',
	DELETE_PATENT_MODAL = 'delete_patent_modal',
	CREATE_MOBILE_CANCELLATION = 'create_mobile_cancellation',
	PARTNER_SIGN_ACTS = 'partner_sign_acts',
	DS_SIGN_ACTS = 'ds_sign_acts',
	CANCEL_ACTS = 'cancel_acts',
	DELETE_ACTS = 'delete_acts',
	RESTORE_ACTS = 'restore_acts',
	GENERATE_PROTOCOL = 'generate_protocol',
	SEND_REFUND_EMAIL = 'send_refund_email',
	REMARK_ACTS = 'remark_acts',
	ANNUL_REQUEST = 'annul_request',
	AVAILABLE_SIGN = 'available_sign',
	CHANGE_STATUS = 'change_status',
	REFUND_ACTS = 'refund_acts',
	ACTS_ACTIONS = 'acts_actions',
	SHOW_ACT_REMARK = 'show_act_remark',
	EXTERNAL_FORMS_MARK = 'external_forms_mark',
	ORD_REPORT_MODAL = 'ord_report_modal',
	REJECTED_VALIDATION_ERRORS_MODAL = 'REJECTED_VALIDATION_ERRORS_MODAL',
	INSTRUCTION_FILE_MODAL = 'instruction_modal_file',
	SEND_GUARANTEE_BY_EMAIL = 'send_guarantee_by_email',
	BG_PUBLICATION = 'bg_publication',
	ADVERTISING_MODAL = 'advertising_modal',
	BG_REQUEST_AGREEMENT = 'bg_request_agreement',
	TWO_FACTOR_AUTH_ENABLE = 'two_factor_auth_enable',
	TWO_FACTOR_AUTH_DISABLE = 'two_factor_auth_disable',
}
